// extracted by mini-css-extract-plugin
export default {"notice":"PCRSMidMonthNotice_notice__rbvdw","icon":"PCRSMidMonthNotice_icon__RUAG5","text":"PCRSMidMonthNotice_text__XnHEO"};